import { useState } from 'react';
import type { ReactNode } from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import type { TextFieldProps } from '@mui/material';

interface DateInputProps {
    value?: string;
    selectMonth?: boolean;
    selectMonthFirst?: boolean;
    selectDayFirst?: boolean;

    required?: boolean;

    onChange(value: string): void;

    width?: number;
    height?: number;
    errorText?: string;
    name?: string;
    label?: ReactNode;
    shrinkLabel?: boolean;
    disabled?: boolean;
    disabledDays?: number[];
    minDate?: Date;
    maxDate?: Date;
    classes?: any;
    margin?: TextFieldProps['margin'];
    variant?: TextFieldProps['variant'];
}

export const DateInput = (props: DateInputProps) => {
    // A bit hacky... value most be correctly formatted YYYY-MM-DD ONLY
    const [selectedDate, setSelectedDate] = useState(
        props.value ? new Date(props.value) : null,
    );

    return (
        <DatePicker
            label={props.label}
            views={props.selectMonth ? ['month'] : undefined}
            value={selectedDate}
            onChange={(date) => {
                setSelectedDate(date);
                if (date && !Number.isNaN(+date)) {
                    const value = new Date(
                        date.getTime() - date.getTimezoneOffset() * 60000,
                    )
                        .toISOString()
                        .slice(0, 10);
                    props.onChange(value);
                }
            }}
            minDate={props.minDate}
            maxDate={props.maxDate}
            format="yyyy-MM-dd"
            slotProps={{
                textField: {
                    fullWidth: true,
                    margin: props.margin,
                    variant: props.variant,
                    inputProps: {
                        autoComplete: 'off',
                        'data-lpignore': 'true',
                    },
                    required: props.required,
                    error: Boolean(props.errorText),
                    helperText: props.errorText,
                },
            }}
        />
    );
};

export default DateInput;
